export type Motor = 'padrao' | 'minimax';

const BASE = 'https://components-ai.magos.empreender.app/api';

export const MOTORES: Record<Motor, { label: string; base: string; detalhe: string }> = {
	padrao: { label: 'GPT + DeepSeek', base: BASE, detalhe: '' },
	minimax: { label: 'MiniMax', base: BASE, detalhe: '' },
};

export const MOTOR_PADRAO: Motor = 'minimax';

export function ehMotor(valor: unknown): valor is Motor {
	return valor === 'padrao' || valor === 'minimax';
}

export function rota(motor: Motor, caminho: string): string {
	return `${MOTORES[ehMotor(motor) ? motor : MOTOR_PADRAO].base}/${caminho.replace(/^\//, '')}`;
}
